export default "__VITE_ASSET__DmiFYS7O__"